import validate from 'validate.js';

export const upperCaseField = value => value && value.toUpperCase();
export const capitalizeField = value =>
  value && validate.capitalize(value.toLowerCase());
export const toBoolean = value => value === 'true';
